import { render, staticRenderFns } from "./PointsIssuanceDialog.vue?vue&type=template&id=342a7efc&scoped=true&"
import script from "./PointsIssuanceDialog.vue?vue&type=script&lang=js&"
export * from "./PointsIssuanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342a7efc",
  null
  
)

export default component.exports